module.exports = __webpack_public_path__ + "static/img/R-C.1fea3c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/R-C.png
// module id = e6Pn
// module chunks = 0